(function () {
  'use strict';

  function initEhPage() {
    initSmoothAnchors();
    initFaq();
    initStickyCta();
    initButtons();
    initNavScroll();
  }

  function initNavScroll() {
    var nav = document.getElementById('primo-eh-nav');
    var hero = document.getElementById('primo-eh-hero');
    if (!nav || !nav.classList.contains('primo-eh-nav--over-hero')) return;

    function updateNav() {
      var threshold = hero ? hero.offsetHeight - nav.offsetHeight - 24 : 80;
      nav.classList.toggle('is-scrolled', window.scrollY > threshold);
    }

    updateNav();
    window.addEventListener('scroll', updateNav, { passive: true });
  }

  function initSmoothAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      if (anchor.dataset.ehAnchorBound === 'true') return;
      anchor.dataset.ehAnchorBound = 'true';
      anchor.addEventListener('click', function (e) {
        var id = anchor.getAttribute('href');
        if (!id || id === '#') return;
        var target = document.querySelector(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initFaq() {
    document.querySelectorAll('.primo-eh-faq__trigger').forEach(function (trigger) {
      if (trigger.dataset.ehFaqBound === 'true') return;
      trigger.dataset.ehFaqBound = 'true';
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        document.querySelectorAll('.primo-eh-faq__trigger').forEach(function (other) {
          if (other === trigger) return;
          other.setAttribute('aria-expanded', 'false');
          var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
          if (otherPanel) otherPanel.hidden = true;
        });
        trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) panel.hidden = expanded;
      });
    });
  }

  function initStickyCta() {
    var sticky = document.getElementById('primo-eh-sticky-cta');
    var heroCta = document.querySelector('.primo-eh-hero [data-eh-enquiry-submit], .primo-eh-hero .primo-eh-cta .primo-btn');
    var formSection = document.getElementById('get-expert-advice') || document.getElementById('get-expert-advice-bottom');

    if (!sticky) return;

    var observeTarget = formSection || heroCta;
    if (!observeTarget || !('IntersectionObserver' in window)) return;
    if (sticky.dataset.ehStickyBound === 'true') return;
    sticky.dataset.ehStickyBound = 'true';

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-hidden', entry.isIntersecting);
        });
      },
      { threshold: 0.05 }
    );

    if (heroCta) observer.observe(heroCta);
    if (formSection) observer.observe(formSection);
  }

  function initButtons() {
    document.querySelectorAll('.template-expert-help .primo-btn').forEach(function (button) {
      if (button.dataset.ehBtnBound === 'true') return;
      button.dataset.ehBtnBound = 'true';
      button.addEventListener('mousedown', function () {
        button.classList.add('is-pressed');
      });
      ['mouseup', 'mouseleave'].forEach(function (evt) {
        button.addEventListener(evt, function () {
          button.classList.remove('is-pressed');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEhPage);
  } else {
    initEhPage();
  }

  document.addEventListener('shopify:section:load', initEhPage);
})();
